import React from 'react';

const RoundBgTick = ({
    bgColor = "#00B0F5"
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <circle cx="12.5" cy="12" r="10" fill={bgColor} />
            <path d="M8.93945 12L11.3135 14.373L16.0595 9.62695" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
}

export default RoundBgTick;